import clsx from 'clsx';
import React, { forwardRef } from 'react';
import styles from './Select.module.css';

export const Select = forwardRef<
  HTMLSelectElement,
  JSX.IntrinsicAttributes &
    React.ClassAttributes<HTMLSelectElement> &
    React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select className={clsx(styles.select, className)} ref={ref} {...props} />
));
